import { createContext, useEffect, useMemo, useState } from "react";

export const MasonryLayoutContext = createContext<{
  columns: number;
  setColumns: (value: number) => void;
}>({
  columns: 3,
  setColumns: () => {},
});

interface Props {
  children: React.ReactNode;
}

const MasonryLayoutProvider = ({ children }: Props) => {
  const [columns, setColumns] = useState(
    localStorage.getItem("mColumns") != null
      ? Number(localStorage.getItem("mColumns"))
      : 3
  );

  useEffect(() => {
    localStorage.setItem("mColumns", columns.toString());
  }, [columns]);

  const values = useMemo(() => {
    return { columns, setColumns };
  }, [columns, setColumns]);

  return (
    <MasonryLayoutContext.Provider value={values}>
      {children}
    </MasonryLayoutContext.Provider>
  );
};

export default MasonryLayoutProvider;
